/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SearchSearchPartialClientIdGet$Params {
  clientId: string;
}

export function searchSearchPartialClientIdGet(http: HttpClient, rootUrl: string, params: SearchSearchPartialClientIdGet$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, searchSearchPartialClientIdGet.PATH, 'get');
  if (params) {
    rb.path('clientId', params.clientId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as MediaStrictHttpResponse<void>;
    })
  );
}

searchSearchPartialClientIdGet.PATH = '/Search/SearchPartial/{clientId}';
